import regionListComponent from "@/components/region/RegionListComponent.vue";
export default {
  name: "regionList",
  components: {
    regionListComponent: regionListComponent
  },
  props: ["loggedUserData"]
};